const request = (method: string) => (endpoint: string) => (body: any) => ({ url: endpoint, method, body });

export const put = request("PUT");
export const post = request("POST");
